import { createCustomerDisplaySnapshot, parseCustomerDisplayBrand, } from '@washday/utilities';
const empty = {
    brand: { name: '' }, currency: 'MXN', lines: [],
    totals: { subtotal: 0, discount: 0, taxes: 0, shipping: 0, total: 0, taxesIncluded: true },
    payment: { status: 'not_started' }
};
/** Owns display timing, never the cashier's cart or payment workflow. */
export class CustomerDisplaySession {
    constructor(instanceId, send) {
        this.instanceId = instanceId;
        this.send = send;
        this.version = 0;
        this.draft = empty;
        this.current = null;
        this.disposed = false;
    }
    get snapshot() { return this.current; }
    /** Publish business identity before any order without restarting display timers. */
    setBrand(brand) {
        var _a, _b, _c, _d;
        if (this.disposed)
            return;
        const safeBrand = parseCustomerDisplayBrand(brand);
        if (!safeBrand)
            return;
        this.draft = Object.assign(Object.assign({}, this.draft), { brand: safeBrand });
        const previous = (_a = this.current) === null || _a === void 0 ? void 0 : _a.brand;
        if (previous && previous.name === safeBrand.name && previous.logoUrl === safeBrand.logoUrl &&
            previous.storeName === safeBrand.storeName)
            return;
        this.emit((_c = (_b = this.current) === null || _b === void 0 ? void 0 : _b.state) !== null && _c !== void 0 ? _c : 'idle', Object.assign(Object.assign({}, ((_d = this.current) !== null && _d !== void 0 ? _d : this.draft)), { brand: safeBrand }));
    }
    setDraft(content) {
        var _a, _b;
        this.draft = content;
        if (((_a = this.current) === null || _a === void 0 ? void 0 : _a.state) === 'payment_pending')
            return;
        if (((_b = this.current) === null || _b === void 0 ? void 0 : _b.state) === 'completed' && !content.lines.length)
            return;
        this.cancelConfirmation();
        this.emit(content.lines.length ? 'editing' : 'idle', content);
        this.armInactivity();
    }
    activity() {
        var _a, _b, _c;
        if (this.disposed || ((_a = this.current) === null || _a === void 0 ? void 0 : _a.state) === 'payment_pending' || ((_b = this.current) === null || _b === void 0 ? void 0 : _b.state) === 'completed')
            return;
        if (((_c = this.current) === null || _c === void 0 ? void 0 : _c.state) === 'idle' && this.draft.lines.length)
            this.emit('editing', this.draft);
        this.armInactivity();
    }
    payment(payment, confirmedContent) {
        this.cancelTimers();
        const content = confirmedContent !== null && confirmedContent !== void 0 ? confirmedContent : (this.current && this.current.state !== 'idle' ? this.current : this.draft);
        const pending = payment.status === 'processing' || payment.status === 'pending';
        this.emit(pending ? 'payment_pending' : 'editing', Object.assign(Object.assign({}, content), { payment }));
        if (!pending)
            this.armInactivity();
    }
    complete(content) {
        this.cancelTimers();
        this.draft = Object.assign(Object.assign({}, empty), { brand: content.brand, currency: content.currency });
        this.emit('completed', content);
        this.confirmationTimer = setTimeout(() => this.emit('idle', Object.assign(Object.assign({}, content), { brand: this.draft.brand })), 8000);
    }
    orderError() {
        this.cancelTimers();
        this.emit('order_error', Object.assign(Object.assign({}, this.draft), { payment: { status: 'not_started' } }));
        this.armInactivity();
    }
    clear() {
        this.cancelTimers();
        this.draft = Object.assign(Object.assign({}, empty), { brand: this.draft.brand, currency: this.draft.currency });
        this.emit('idle', this.draft);
    }
    dispose() {
        this.cancelTimers();
        this.disposed = true;
    }
    emit(state, content) {
        if (this.disposed)
            return;
        const snapshot = createCustomerDisplaySnapshot(Object.assign(Object.assign({}, content), { state, publisherInstanceId: this.instanceId, version: ++this.version, timestamp: Date.now() }));
        if (snapshot) {
            this.current = snapshot;
            this.send(snapshot);
        }
    }
    armInactivity() {
        clearTimeout(this.idleTimer);
        this.idleTimer = setTimeout(() => this.emit('idle', this.draft), 600000);
    }
    cancelConfirmation() { clearTimeout(this.confirmationTimer); }
    cancelTimers() { clearTimeout(this.idleTimer); this.cancelConfirmation(); }
}
